import { z } from "zod";
import { getBaseFilterOutput } from "../BaseFilterOutput";
import { GetMyReportsExecutionHistoryDtoSchema, GetMyReportsExecutionHistoryDto } from "./GetMyReportsExecutionHistoryDto";

export const GetMyReportsExecutionHistoryOutputSchema = getBaseFilterOutput<GetMyReportsExecutionHistoryDto>(GetMyReportsExecutionHistoryDtoSchema);

export type GetMyReportsExecutionHistoryOutput = z.infer<typeof GetMyReportsExecutionHistoryOutputSchema>;